<template>
  <section id="Palavras-Chave" class="section-item">
    <h1>{{ $t("title.keywords") }}</h1>

    <section id="api-Palavras-Chave-PutKeywordsId">
      <h2>{{ $t("title.keywords") }} - {{ $t("title.update_by_id") }}</h2>
      <p>{{ $t("words_key.update_keyword_by_id_method") }}</p>
      <div class="">
        <div class="put type">PUT</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/keywords/:id</code></pre>
      </div>
      <div class="code-toggle">
        <button class="json">JSON</button>
      </div>

      <pre v-if="selectedTab === 'json'">
            <code class="language-json">{
  "word": "teste2"
}</code>
          </pre>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.keyword_id") }}</td>
          </tr>
          <tr>
            <td>word</td>
            <td>String</td>
            <td>{{ $t("table.new_keyword") }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section id="api-Palavras-Chave-PostKeywords">
      <h2>{{ $t("title.keywords") }} - {{ $t("title.create_keyword") }}</h2>
      <p>{{ $t("words_key.create_keyword_method") }}</p>
      <div class="">
        <div class="post type">POST</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/keywords</code></pre>
      </div>
      <div class="code-toggle">
        <button class="json">JSON</button>
      </div>

      <pre v-if="selectedTab === 'json'">
            <code class="language-json">{
  "word": "teste"
}</code>
          </pre>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>word</td>
            <td>String</td>
            <td>{{ $t("table.keyword_value") }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section id="api-Palavras-Chave-DeleteKeywordsId">
      <h2>{{ $t("title.keywords") }} - {{ $t("title.exclude_id") }}</h2>
      <p>{{ $t("words_key.delete_keyword_by_id_method") }}</p>
      <div class="">
        <div class="delete type">DELETE</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/keywords/:id</code></pre>
      </div>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.keyword_id_to_delete") }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section id="api-Palavras-Chave-GetKeywords">
      <h2>{{ $t("title.keywords") }} - {{ $t("title.list_keywords") }}</h2>
      <p>{{ $t("words_key.list_keywords_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/keywords</code></pre>
      </div>
    </section>
  </section>
</template>

<script>
import hljs from "highlight.js";
import "highlight.js/styles/an-old-hope.css";

export default {
  name: "KeyWordsComponent",
  data() {
    return {
      selectedTab: "json",
    };
  },
  mounted() {
    this.highlightCode();
  },
  watch: {
    selectedTab() {
      this.$nextTick(() => {
        this.highlightCode();
      });
    },
  },
  methods: {
    highlightCode() {
      document.querySelectorAll("pre code").forEach((block) => {
        hljs.highlightBlock(block);
      });
    },
  },
};
</script>

<style scoped>
.sms-method {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1rem;
}

pre[class*="language-"] {
  background-color: #000 !important;
  color: var(--green-code);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  overflow-x: auto;
  white-space: pre-wrap;
  font-family: var(--font-code);
  margin-bottom: 20px;
}
</style>
